import React from 'react'
import InvestigacionAtaquesDdosResumen from './InvestigacionAtaquesDdosResumen'
import BuenasPracticas from './BuenasPracticas'
import Mitigacion from './Mitigacion'
import Objetivo from './Objetivo'
import Conclusion from './Conclusion'
import Referencia from './Referencia'
import Relevamiento from './Relevamiento'
import DescargarArchivo from './DescargarArchivo'

function InvestigacionSobreAtaquesDdos() {
    return (
        <>  
        <InvestigacionAtaquesDdosResumen />
        <DescargarArchivo />
        <Objetivo />
        <Relevamiento/>
        <BuenasPracticas />
        <Mitigacion/> 
        <Conclusion/>
        <Referencia />
        </>
    )
}

export default InvestigacionSobreAtaquesDdos
